import { Divider, List, ListItem, ListItemText, Typography } from "@mui/material"


const DataSharing = () => {
  return (
    <>
        <Typography variant="h4" fontWeight="bold" gutterBottom>5. Data Sharing and Disclosure</Typography>
        <Typography sx={{ fontSize: '1.1rem' }}>
            <List>
                <ListItem>
                    <ListItemText>
                     <b> • No third-party sharing:</b> We do not share your data with any third parties, ad 
networks, or data brokers.

                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                     <b> • Internal use only:</b>   Data is accessible only by authorized users of the 
customer organization, such as admins or managers

                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                     <b>   • Legal compliance:</b>   We may disclose information if required by law, regulatory 
authorities, or legal processes.
                    </ListItemText>
                </ListItem>
                <ListItem>
                    <ListItemText>
                     <b>   •  WhatsApp Integration:</b>   Currently not available. In future versions, users may 
manually share documents using system share options.
                    </ListItemText>
                </ListItem>
            </List>
        </Typography>
        <Divider sx={{ my: 2 }} />
    </>
  )
}

export default DataSharing